<template>
  <div class="form-group-container">
    <div class="form-group-item">
      <FormGroup>
        <h5 class="name">เวลาเริ่มต้น</h5>
        <DateTimePicker
          v-model="scheduleItem.startTime"
          type="time"
          placeholder="กรุณาเลือกเวลาเริ่มต้น" />
      </FormGroup>
    </div>
    <div class="form-group-item">
      <FormGroup>
        <h5 class="name">เวลาจบ</h5>
        <DateTimePicker
          v-model="scheduleItem.endTime"
          type="time"
          placeholder="กรุณาเลือกเวลาจบ" />
      </FormGroup>
    </div>
  </div>
</template>

<script>
import FormGroup from '@/components/FormGroup.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';

export default {
  props: {
    scheduleItem: {
      type: Object,
      default: () => {},
    },
    updateScheduleItemStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FormGroup,
    DateTimePicker,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';


.form-group-container {
  display: flex;

  .form-group-item {
    margin-right: $spacer * 2;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
